
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.417 3.528L12.776.473l-1.022 1.21 3.642 3.057 1.021-1.212zM5.24 1.684L4.226.473.584 3.52l1.021 1.212L5.24 1.684zm3.657 3.65H7.71v4.75l3.76 2.256.594-.974L8.896 9.49V5.333zm-.395-3.167a7.126 7.126 0 100 14.25 7.126 7.126 0 000-14.25zm0 12.666a5.538 5.538 0 01-5.542-5.541A5.538 5.538 0 018.501 3.75a5.538 5.538 0 015.541 5.542 5.538 5.538 0 01-5.541 5.541z","fill":"#757575"}})])
          )
        }
      }
    